import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChildren, QueryList, NgZone } from '@angular/core';
import { ModalController, AlertController, Platform } from '@ionic/angular';
import { RequestCreationService } from 'src/app/core/services/request-creation/request-creation.service';
import { UtilsService } from 'src/app/core/services/utils/utils.service';
import { FailureCreation, FailureSelection } from 'src/app/models/Failure-creation.model';
import { Router } from '@angular/router';
import { Header } from 'src/app/models/header.model';
import { AddFailureModalComponent } from './add-failure-modal/add-failure-modal.component';
import { CustomAlertComponent } from 'src/app/shared-components/custom-alert/custom-alert.component';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { NetworkService } from 'src/app/core/services/network/network.service';

@Component({
  selector: 'app-requirement-form',
  templateUrl: './requirement-form.page.html',
  styleUrls: ['./requirement-form.page.scss'],
})
export class RequirementFormPage implements OnInit {

  public header: Header = {
    title: 'Crear Solicitud',
    icon: 'add',
    principalPage: false
  }

  public selectedFailures: FailureSelection[] = [];
  public createButtonDisabled: boolean = false;
  private company;
  private unitId;
  private leaveAfterCreation: boolean = false;
  private connectionSubscription: Subscription;
  public isOnline: Boolean = false;

  @ViewChildren('failures') listedFailures: QueryList<any>;

  constructor(
    public modalCtrl: ModalController,
    private utils: UtilsService,
    private requestCreationService: RequestCreationService,
    private router: Router,
    public zone: NgZone,
    private location: Location,
    private networkService: NetworkService,
    private alertController: AlertController,
    private platform: Platform,
    private translate: TranslateService
  ) {
    this.requestCreationService.getFilesAvailability()
      .subscribe(() => this.checkImagesAvailability());

    this.connectionSubscription = this.networkService.getConnectionStatus()
      .subscribe(data => this.zone.run(() => this.isOnline = data));

    this.networkService.getInitialConecctionState().then(data => this.zone.run(() => this.isOnline = data))
  }

  async ngOnInit() {
    this.header.title = this.translate.instant('requirement-form.Crear Solicitud')
  }

  async ionViewDidEnter() {
    try {
      const { company, selectedUnitId } = await this.utils.getFromStorage('unitParams');
      this.company = company;
      this.unitId = selectedUnitId;
      this.addFailure();
    } catch (e) {
      this.utils.ifNoNavParamRedirect(e);
    }
  }

  async addFailure() {
    const modal = await this.modalCtrl.create({
      component: AddFailureModalComponent,
      backdropDismiss: false,
    });
    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data === 'close' && !this.selectedFailures.length)
      this.location.back();
    else if (data && data != 'close') {
      let repeated = false;
      for (const iterator of data) {
        const existentFailure = this.selectedFailures.find(el => el.configId === iterator.configId && el.detailId === iterator.detailId);
        if (!existentFailure)
          this.selectedFailures.push(iterator);
        else
          repeated = true;
      }
      if (repeated) {
        const alertMsg = await this.alertController.create({
          subHeader: this.translate.instant('requirement-form.Una o más fallas ya están registradas'),
          buttons: ['OK']
        });

        await alertMsg.present();
      }
    }
  }

  deleteFlaw(id: string) {
    this.selectedFailures.splice(this.selectedFailures.findIndex(el => `${el.configId}${el.detailId}` === id), 1);
    this.listedFailures['_results'].splice(this.listedFailures['_results'].findIndex(el => el.failureIdentifier === id), 1);

    this.checkImagesAvailability()
  }

  async confirmRequestCreation() {
    const alert = await this.alertController.create({
      header: this.translate.instant('requirement-form.¿Confirma creación de solicitud?'),
      subHeader: this.selectedFailures.length === 1 ? this.translate.instant('requirement-form.Puede ingresar múltiples fallas por solicitud') : '',
      buttons: [
        {
          text: this.translate.instant('requirement-form.Cancelar'),
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => { }
        }, {
          text: this.translate.instant('requirement-form.Enviar'),
          handler: () => {
            this.createRequirement();
          }
        }
      ]
    });

    await alert.present();
  }

  async createRequirement() {
    console.log(this.platform.platforms());

    if (this.isOnline) {
      const loader = await this.utils.presentLoading(this.translate.instant('requirement-form.Creando solicitud...'));
      let failures: FailureCreation[] = [];

      this.selectedFailures.map((el) => {
        const archivos = el.attachments.map(el => el['name'] ? el['name'] : el);

        failures.push({
          configuracion_id: el.configId,
          detalle_id: el.detailId,
          observacion: el.observation === this.translate.instant('requirement-form.Sin observación') ? null : el.observation,
          archivos: [...archivos]
        })
      });
      const origin = this.platform.is('capacitor') ? 'app' : 'web';
      this.requestCreationService.createRequest(this.company, this.unitId, { fallas: failures, origen: origin })
        .subscribe(async ({ data, error, operation }) => {
          loader.dismiss();
          if (error) {
            let failuresToDelete: FailureSelection[] = [];
            if (error.status == 422 && error.error.errors && error.error.errors.length) {
              let errorString = '';
              error.error.errors.map(el => {
                if (el.includes('en proceso')) {
                  const failureToDeleteIndex = parseInt(el.substr(7, 1)) - 1;
                  failuresToDelete = [...failuresToDelete, this.selectedFailures.find((slctd, index) => index === failureToDeleteIndex)]
                } else
                  errorString += `${el}\n`
              })
              let duplicateFailuresErrorString = '';
              if (failuresToDelete.length) {
                for (const iterator of failuresToDelete) {
                  const index = this.selectedFailures.findIndex(el => el.name === iterator.name);
                  duplicateFailuresErrorString += `<strong>&bull;</strong> <small class='failure-in-process'>${this.translate.instant('requirement-form.Falla #')}${index + 1}: ${this.selectedFailures
                    .find(el => el.name === iterator.name).name}</small> </br>`
                }
                const alertMsg = await this.alertController.create({
                  subHeader: this.translate.instant('requirement-form.Las siguientes fallas ya se encuentran en proceso de posventa:'),
                  message: duplicateFailuresErrorString,
                  backdropDismiss: false,
                  buttons: [{
                    text: this.translate.instant('requirement-form.Cerrar')
                  }, {
                    text: this.translate.instant('requirement-form.Eliminar fallas duplicadas'),
                    handler: () => {
                      for (const iterator of failuresToDelete) {
                        this.selectedFailures.splice(this.selectedFailures.findIndex(el => el.name === iterator.name), 1)
                      }
                    }
                  }]
                });
                await alertMsg.present();
              }
              if (errorString)
                this.utils.showMessage(errorString);
            } else
              this.utils.showMessage(operation);
          } else {
            const modal = await this.modalCtrl.create({
              component: CustomAlertComponent,
              backdropDismiss: false,
              cssClass: 'custom-alert'
            });
            await modal.present();
            this.leaveAfterCreation = true;
            this.router.navigate(['/requests'], { replaceUrl: true });
            await modal.onDidDismiss();
          }
        })
    } else {
      this.utils.showMessage(this.translate.instant('requirement-form.Sin conexión a internet'));
    }
  }

  checkImagesAvailability() {
    this.zone.run(() => {
      let shouldDisabled = false;
      this.listedFailures['_results'].map(({ files }) => {
        files.map(f => {
          if (!f.availability)
            shouldDisabled = true;
        })
      })
      this.createButtonDisabled = shouldDisabled;
    })
  }

  canLeave() {
    return this.selectedFailures.length
  }

  canLevaeAfterCreation() {
    return this.leaveAfterCreation
  }

  checkIfFiles() {
    const failsWithImages = this.selectedFailures.filter(el => el.attachments.length)
    return failsWithImages.length ? true : false;
  }


}
